import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {FormikSelect, FormikTextInput} from '@flexinet/ui-components';
import {I18n} from '@aws-amplify/core';

// FNP-536 / FNP-594: backend-supported filters (UsageEventsFilterInput = accountId,
// customerId, meterCode, unresolvedCustomer, unmetered). The two booleans only narrow
// server-side in their truthy ('true') case — buildQueryFilter drops falsy values — so
// each is an "All / Yes" select (the "why didn't this bill?" toggles), not a tri-state.
export const FilterFormComponent = () => {
    const yesOnlyOptions = [
        {value: '', label: I18n.get('All')},
        {value: 'true', label: I18n.get('Yes')},
    ];

    return (
        <Stack gap='md' my='md'>
            <Field
                name='meterCode'
                label={I18n.get('Meter Code')}
                placeholder='e.g. email.sent'
                component={FormikTextInput}
            />
            <Field
                name='customerId'
                label={I18n.get('Customer ID')}
                component={FormikTextInput}
            />
            <Field
                name='accountId'
                label={I18n.get('Account ID')}
                component={FormikTextInput}
            />
            <Field
                name='unresolvedCustomer'
                label={I18n.get('Unresolved Customer')}
                description={I18n.get('Events whose paying customer is not yet resolved.')}
                data={yesOnlyOptions}
                component={FormikSelect}
            />
            <Field
                name='unmetered'
                label={I18n.get('Unmetered')}
                description={I18n.get('Events whose meter code is not in the catalog.')}
                data={yesOnlyOptions}
                component={FormikSelect}
            />
        </Stack>
    );
};
